import { SignUpPersonalPartnerPayloadState } from "@/types/payload/sign-up-personal-partner-payload-state";
import { atom } from "recoil";

export const initSignUpPersonalPartnerPayloadState = {
  file: undefined,
  email: "",
  password: "",
  name: "",
  businessName: "",
  businessNumber: "",
  phone: "",
  jibun: "",
  road: "",
  detail: "",
  postalCode: "",
  taxReceiptEmail: "",
  signupCode: "",
};

export const signUpPersonalPartnerPayloadState =
  atom<SignUpPersonalPartnerPayloadState>({
    key: "signUpPersonalPartnerPayloadState",
    default: initSignUpPersonalPartnerPayloadState,
  });
